"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentName = exports.baseNameGeneratorConfig = void 0;
exports.generateDocumentName = generateDocumentName;
exports.slugifyDocumentName = slugifyDocumentName;
exports.slugify = slugify;
exports.isDocumentNameValid = isDocumentNameValid;
const tslib_1 = require("tslib");
/**
 * Functions for generating unique names for documents that follow the flux style of whimsical
 * science fiction-y names.
 */
const slugify_1 = tslib_1.__importDefault(require("slugify"));
const unique_names_generator_1 = require("unique-names-generator");
const zod_1 = require("zod");
const structure_1 = require("./structure");
/**
 * Adjectives that should never be included in document names.  Anything that's offensive
 * or could be considered offensive to users should be added to this list to prevent the term
 * from being included in a document name.
 */
const bannedAdjectives = ["sexual", "drunk", "religious", "brown", "naked", "communist"];
/**
 * We use these devices from science fiction as our base for naming documents.
 */
const scifyDevices = [
    "Flux Capacitor",
    "Hoverboard",
    "Neuralizer",
    "Electronic Thumb",
    "Mr. Fusion",
    "TARDIS",
    "Transporter",
    "Replicator",
    "Sonic Screwdriver",
    "KITT",
    "R2-D2",
    "Matter Compiler",
    "Tricorder",
    "Antigravity Battle Room",
    "Speeder Bike",
    "Heat-Ray",
    "Robot Maid",
    "Robot Vacuum",
    "Power Laces",
    "X-Wing",
    "Gadget Copter",
    "Liquid Breathing Apparatus",
    "Interocitor",
    "Jetpack",
    "TV Glasses",
    "Scramble Suit",
    "Teleporter",
    "Point-of-view gun",
    "Battle Mech",
    "Flubber",
    "Electromagnetic Shrinking Machine",
    "Time Machine",
    "Flying Cab",
    "Esper Photo Analyser",
    "Lightcycle",
    "Dejarik",
    "Wall-E",
    "Memory Implanter",
    "Universal Remote",
    "Proton Packs",
    "T-800",
    "Translation Collar",
    "Massive Robot Spider",
    "P.K.E. Meter",
    "Ecto Goggles",
    "Holodeck",
    "Tractor Beam",
    "Warp Drive",
    "Carbonite Freezer",
    "Pip boy",
];
exports.baseNameGeneratorConfig = {
    dictionaries: [unique_names_generator_1.adjectives.filter((adj) => !bannedAdjectives.includes(adj)), unique_names_generator_1.colors, scifyDevices],
    separator: " ",
    style: "capital",
};
/**
 * Combines all of the above into a single name generator.
 */
function generateDocumentName() {
    return (0, unique_names_generator_1.uniqueNamesGenerator)(exports.baseNameGeneratorConfig);
}
/**
 * Globally configures slugify to include some additional necessary characters.
 */
slugify_1.default.extend({
    "☢": "radioactive",
    "+": "plus",
    // To support names like 1.1pF
    ".": "p",
    ",": "c",
    // Electrical-related, overrides the greek ones
    μ: "u",
    Ω: "ohm",
});
/**
 * Compute the slug for a given document name
 *
 * Note that it is NOT safe to use this function to produce a slug for a document based on its name from the frontend
 * e.g. during an import. That's because you cannot guarantee uniqueness for a given owner handle, not even by reading
 * all the documents under that owner handle (because there may be some the importing user cannot read). You must instead
 * use the backend to produce a valid slug.
 *
 * Instead:
 *  - On the backend, use the DocumentRenameService
 *  - On the frontend, use the getProjectName function on the FunctionsAdapter
 */
function slugifyDocumentName(name) {
    return structure_1.Slug.parse(slugify(name));
}
/**
 * Slugifies a string
 *
 * Used to slugify the suffix of a project slug when we're making a unique one
 */
function slugify(str) {
    return (0, slugify_1.default)(str, {
        lower: true,
        strict: true,
    });
}
exports.DocumentName = zod_1.z.string().min(3).max(150).trim();
function isDocumentNameValid(documentName) {
    return exports.DocumentName.safeParse(documentName).success && structure_1.Slug.safeParse(slugify(documentName)).success;
}
//# sourceMappingURL=names.js.map